export const plans = [
  {
    id: 17, // 해당 플랜의 id
    isDone: true, // 사용자가 완료 버튼을 눌렀는지 아닌 여부
    title: '이성인 선배님과 밥 먹기로 함', //plan의 내용
    promise_time: 1030, // 약속한 날짜
    is_mine: true, //현재 로그인한 유저가 작성한 글인지 남들의 약속을 가져온 것인지 체킹
  },
  {
    id: 18,
    isDone: false,
    title: '모각코 하기',
    promise_time: 1040,
    is_mine: true,
  },
  {
    id: 19,
    isDone: false,
    title: '준현 선배님과 밥 먹기',
    promise_time: 1310,
    is_mine: false,
  },
  {
    id: 19,
    isDone: false,
    title: '전자기학 공부하기',
    promise_time: 1450,
    is_mine: true,
  },
  {
    id: 19,
    isDone: false,
    title: '물리화학 공부하기',
    promise_time: 1620,
    is_mine: false,
  },
  {
    id: 19,
    isDone: false,
    title: '광고론 공부하기',
    promise_time: 1835,
    is_mine: true,
  },
  {
    id: 19,
    isDone: false,
    title: '운전면허 공부하기',
    promise_time: 2115,
    is_mine: false,
  },
  {
    id: 19,
    isDone: false,
    title: '토익 공부하기',
    promise_time: 2230,
    is_mine: true,
  },
];
